<template>
    <div id="attendee-list">
        <fg-modal title="Käyttäjät" :show="showUserModal" @ok="selectUsers" @cancel="showUserModal=false">
            <div class="row">
                <div class="col-sm-12">
                    <div class="input-group keyword">
                          <span class="input-group-addon" id="search-addon">
                              <i class="glyphicon glyphicon-search"></i>
                          </span>
                        <input
                            type="text" v-on:keyup.enter="searchUser" v-model="modal_keyword" class="form-control"
                            placeholder="Hae nimellä tai SAP-numerolla" aria-describedby="search-addon">
                    </div>
                </div>
            </div>
            <div class="user-list">
                <div v-if="users.total === 0">
                    Ei varusmiehiä valittavana
                </div>
                <article v-for="user in users.data">
                    <div class="col-sm-2 hidden-xs">
                        <img
                            v-if="user.avatar === ''" width="24" src="/images/avatar.svg" class="img-responsive"
                            alt="">
                        <img
                            v-if="user.avatar !== ''" width="24" src="/images/users/${ user.avatar }"
                            class="img-responsive" alt="">
                    </div>
                    <div class="col-sm-4 col-xs-6">
                        {{ user.name }}
                    </div>
                    <div class="col-sm-4">
                        {{ user.unit.name }}
                    </div>
                    <div class="col-sm-2">
                        <input v-model="user.selected" id="userSelect" type="checkbox" :value="user.id">
                    </div>
                </article>
                <div v-if="this.page > 1" class="row">
                    <div class="col-sm-12">
                        <a @click="loadUserListAndDecrement()" class="btn btn-block btn-primary">Näytä edellinen</a>
                    </div>
                </div>
                <div v-if="users.last_page > 1 && users.current_page < users.last_page" class="row">
                    <div class="col-sm-12">
                        <a @click="loadUserListAndIncrement()" class="btn btn-block btn-primary">Näytä seuraava</a>
                    </div>
                </div>
            </div>
        </fg-modal>
        <div class="row">
            <div :class="{'col-sm-12': isConscript, 'col-sm-10': !isConscript}">
                <div class="input-group keyword">
                  <span class="input-group-addon" id="search-addon">
                      <i class="glyphicon glyphicon-search"></i>
                  </span>
                    <input
                        type="text" v-model="keyword" class="form-control"
                        placeholder="Hae nimellä tai SAP-numerolla" aria-describedby="search-addon">
                </div>
            </div>
            <div v-if="!isConscript" class="col-sm-2">
                <button id="showUserSearch" class="btn btn-block btn-primary" @click="toggleShowUserModal"><i
                    class="fa fa-user-plus" aria-hidden="true"></i></button>
            </div>
        </div>
        <div v-if="attendees.length === 0">
            Ei näytettäviä osallistujia
        </div>
        <article v-for="attendee in attendees">
            <div :class="{'hidden-xs col-sm-2': showsCheckIn, 'col-xs-2 col-sm-2': showsCheckIn === false }">
                <img v-if="attendee.avatar === ''" width="48" src="/images/avatar.svg" class="img-responsive" alt="">
                <img
                    v-if="attendee.avatar !== ''" width="48" :src="`/images/users/${attendee.avatar}`"
                    class="img-responsive" alt="">
            </div>
            <div :class="{'col-xs-6 col-sm-7': showsCheckIn, 'col-xs-10 col-sm-10' : showsCheckIn == false}">
                <sub>{{ attendee.unit.name }}</sub>
                <div>{{ attendee.name }}</div>
                <span v-show="isOnGoing" v-if="attendee.attendances.length > 0" class="label label-success">
                    {{attendee.attendances.length}}
                </span>
                <sub v-show="showLastCheckIn(attendee)" v-if="attendee.attendances.length > 0">
                    Viimeisin sisäänkirjaus {{ updatedAt(attendee) }}
                </sub>
            </div>

            <div v-if="showsCheckIn || showsCheckOut" class="col-xs-6 col-sm-3">
                <a
                    v-if="enableCheckIn(attendee) && showsCheckIn" id="checkIn" @click="checkIn(attendee)"
                    class="btn btn-primary btn-block">
                    Kirjaa sisään
                </a>
                <a v-else disabled="disabled" class="btn btn-block btn-blocked">
                    Kirjattu sisään
                </a>
                <a
                    v-if="enableCheckOut(attendee) && showsCheckOut" id="checkOut" @click="checkOut(attendee)"
                    class="btn btn-success btn-block">
                    Kirjaa ulos
                </a>
                <a v-else disabled="disabled" class="btn btn-block btn-blocked">
                    Kirjattu ulos
                </a>
            </div>

        </article>
    </div>
</template>

<script>
    import FgModal from './FgModal.vue';
    import { EventBus } from "../event-bus";
    import Swal from 'sweetalert2';
    import axios from 'axios';
    import moment from 'moment';


    export default {
        components: {
            FgModal
        },
        props: {
            activityId: {
                type: Number,
                default: 0
            },
            showsCheckIn: {
                type: Boolean,
                default: false
            },
            showsCheckOut: {
                type: Boolean,
                default: false
            },
            datetime: {
                type: Number,
                default: 0,
            }
        },
        watch: {
            datetime() {
                this.datetime_data = this.datetime
                this.loadList()
            }
        },
        data() {
            return {
                attendees: [],
                users: [],
                activity: {},
                checkIns: [],
                checkOuts: [],
                keyword: '',
                modal_keyword: '',
                showUserModal: false,
                isConscript: true,
                page: 1,
                datetime_data: 0
            }
        },
        mounted() {
            if (this.datetime !== 0) {
                this.datetime_data = this.datetime
                this.loadList();
            }

            EventBus.$on('onNewRegistration', () => {
                this.onNewRegistration()
            });

            EventBus.$on('showsCheckIn', () => {
                this.showCheckIn()
            });

            EventBus.$on('showsCheckOut', () => {
                this.showCheckOut()
            });

            EventBus.$on('onSelectedDateChange', () => {
                this.onSelectedDateChange()
            });
        },
        methods:
            {
                loadList() {
                    axios.get('/api/activities/' + this.activityId + '/attendees', {
                        params: {
                            'activity_date': this.datetime
                        }
                    }).then((response) => {
                        this.attendees = response.data['attendees'];
                        this.activity = response.data['activity'];
                        this.isConscript = response.data['is_conscript'];
                        this.isOnGoing = (this.activity.type === 'ongoing');
                        this.initData();
                    });
                },
                loadUserList() {
                    axios.get('/api/activities/' + this.activityId + '/users', {
                        params: {
                            'page': this.page,
                            'datetime': this.datetime
                        }
                    }).then(response => {
                        this.users = response.data;
                    });
                },
                searchUser() {
                    axios.get('/api/activities/' + this.activityId + '/users', {
                        params: {
                            'keyword': this.modal_keyword
                        }
                    }).then(response => {
                        this.users = response.data;
                    });
                },
                checkIn(attendee) {
                    axios.post('/api/checkin/activity/' + this.activityId, {
                        'attendee_id': attendee.user_id,
                        'datetime': this.datetime_data,
                    }).then(response => {
                        attendee.attendances.push(response.data);
                        this.checkIns.push(attendee.user_id + '_' + this.isoDate);
                    }).catch(err => {
                        Swal.fire({
                            type: 'error',
                            title: "Jokin meni pieleen.",
                            text: err.response.data.errors.title,
                        })
                    });
                },
                checkOut(attendee) {
                    axios.post('/api/checkout/activity/' + this.activityId, {
                        'attendee_id': attendee.user_id,
                        'datetime': this.datetime_data,
                    })
                        .then((response) => {
                            attendee.attendances.push(response.data);
                            this.checkOuts.push(attendee.user_id + '_' + this.isoDate);
                        })
                        .catch(err => {
                            Swal.fire({
                                type: 'error',
                                title: "Jokin meni pieleen.",
                                text: err.response.data.errors.title,
                            })
                        });
                },
                enableCheckIn(attendee) {
                    if (this.isOnGoing) {
                        if (!this.showsCheckOut) {
                            return true;
                        }
                        return (this.checkIns.indexOf(attendee.user_id + '_' + this.isoDate) <= this.checkOuts.indexOf(attendee.user_id + '_' + this.isoDate));
                    }

                    return (this.checkIns.indexOf(attendee.user_id + '_' + this.isoDate) === -1);
                },
                enableCheckOut(attendee) {
                    if (this.isOnGoing) {
                        return (this.checkIns.indexOf(attendee.user_id + '_' + this.isoDate) >= this.checkOuts.indexOf(attendee.user_id + '_' + this.isoDate));

                    }
                    return this.checkOuts.indexOf(attendee.user_id + '_' + this.isoDate) === -1;
                },
                showLastCheckIn(attendee) {
                    if (this.isOnGoing) {
                        return true;
                    }

                    if (this.activity.type === 'one_time') {
                        return false;
                    }

                    return this.checkIns.indexOf(attendee.user_id + '_' + this.isoDate) !== -1;
                },
                initData() {
                    for (var i = 0; i < this.attendees.length; i++) {
                        var attendee = this.attendees[i];
                        for (var j = 0; j < attendee.attendances.length; j++) {
                            if (this.checkIns.indexOf(attendee.user_id + '_' + this.isoDate) === -1) {
                                this.checkIns.push(attendee.user_id + '_' + this.formatISODate(attendee.attendances[j].activity_date));
                            }
                            if (attendee.attendances[j].checkOut !== undefined) {
                                this.checkOuts.push(attendee.user_id + '_' + this.formatISODate(attendee.attendances[j].activity_date));
                            }
                        }
                    }
                },
                updatedAt(attendee) {
                    var lastKey = Object.keys(attendee.attendances).pop();
                    // var today = new moment()
                    // return today.diff(last, 'hours');
                    var updated = attendee.attendances[lastKey].updated_at;
                    return this.formatDatetime(updated);
                },
                formatDatetime(date) {
                    return new moment(date, 'YYYY-MM-DD H:mm:ss').format('DD.MM.YYYY H:mm:ss');
                },
                formatISODate(date) {
                    return new moment(date, 'YYYY-MM-DD H:mm:ss').format('YYYY-MM-DD');
                },
                toggleShowUserModal() {
                    this.loadUserList();
                    this.showUserModal = !this.showUserModal;
                },
                selectUsers() {
                    var self = this;
                    var selected = this.users.data.filter(function (user) {
                        return user.selected;
                    }).map(function (user) {
                        self.attendees.push(user);
                        self.register(user);
                    });
                    EventBus.$emit('closeModal');
                },
                register(attendee) {
                    axios.post('/api/activities/register/' + this.activityId, {
                            'activity_date': this.datetime_data,
                            'attendee_id': attendee.id,
                    }).catch(err => {
                        Swal(err.data.errors.title)
                    }).finally(() => {
                        this.showUserModal = false;
                    });
                },
                loadUserListAndIncrement() {
                    this.page += 1;
                    this.loadUserList();
                },
                loadUserListAndDecrement() {
                    if (this.page >= 2) {
                        this.page -= 1;
                    }
                    this.loadUserList();
                },

                //Events:
                showCheckIn() {
                    this.showsCheckIn = true
                },
                showCheckOut() {
                    this.showsCheckOut = true
                },
                onSelectedDateChange(datetime) {
                    this.datetime_data = datetime;
                    this.users = [];
                    this.page = 1;
                    this.loadList();
                },
                onNewRegistration(datetime) {
                    this.datetime_data = datetime;
                    this.loadList();
                }
            },
        computed:
            {
                isoDate: function () {
                    return moment.unix(this.datetime_data).format('YYYY-MM-DD');
                }
            },
    }
</script>

<style lang="scss">
    @import 'resources/assets/sass/_variables.scss';

    .user-list {
        overflow-y: scroll;
        height: 70vh;
    }


    #attendee-list {
        font-size: 1.4rem;

        input {
            @media (max-width: 500px) {
                font-size: 1.2rem;
            }
        }

        article {
            @media (max-width: 500px) {
                font-size: 1.1rem;
            }
        }
    }

    .attendees {
        padding-left: 15px;
        padding-right: 15px;

        .keyword {
            margin-bottom: 10px;
        }

        @media (max-width: 500px) {
            .btn {
                font-size: 1.2rem;
            }
        }

        article {
            background: $panel-default-body;
            padding-top: 5px;
            padding-bottom: 5px;
            margin-bottom: 5px;
            box-shadow: 0 1px 0 0 rgba(0, 0, 0, .1);
            display: flex;
            align-items: center;
        }

        a.title {
            text-transform: uppercase;
        }
    }
</style>
